import React, { Suspense, lazy, useRef, useContext } from 'react'
import { Loading } from '../../shared/components'
import { TicketsAppContext } from '../context/tickets-app-context'
import { STEPS } from '../helpers/steps'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import './slide.css'

const LoadableDateTickets = lazy(() => import('./date-tickets'))
const LoadableEvents = lazy(() => import('./events'))
const LoadableParty = lazy(() => import('./party'))
const LoadableAddOns = lazy(() => import('./add-ons'))

export default function Content() {
  const { step, direction } = useContext(TicketsAppContext)

  const nodeRefs = useRef(new Map())

  const getNodeRef = step => {
    if (!nodeRefs.current.has(step)) {
      nodeRefs.current.set(step, React.createRef())
    }
    return nodeRefs.current.get(step)
  }

  const renderStepView = step => {
    switch (Number(step)) {
      case STEPS.DATETICKETS:
        return (
          <Suspense
            fallback={<Loading text="Fetching latest ticket data..." />}
          >
            <LoadableDateTickets />
          </Suspense>
        )
      case STEPS.EVENTS:
        return (
          <Suspense fallback={<Loading text="Loading events..." />}>
            <LoadableEvents />
          </Suspense>
        )
      case STEPS.PARTY:
        return (
          <Suspense fallback={<Loading text="Loading party data..." />}>
            <LoadableParty />
          </Suspense>
        )
      case STEPS.ADDONS:
        return (
          <Suspense fallback={<Loading text="Checking for add-ons..." />}>
            <LoadableAddOns />
          </Suspense>
        )
    }
  }

  return (
    <TransitionGroup
      className={`tickets-content direction-${direction.toLowerCase()}`}
    >
      <CSSTransition
        nodeRef={getNodeRef(step)}
        classNames="slide"
        timeout={300}
        key={step}
        unmountOnExit={true}
      >
        <div
          ref={getNodeRef(step)}
          className="slide"
        >
          {renderStepView(step)}
        </div>
      </CSSTransition>
    </TransitionGroup>
  )
}
